import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import ListState from '../states/list.state';
import { fetchFieldHistorySummary } from '../actions/spa.actions';

const initialState: ListState = {
  loading: false,
  data: [],
  error: null,
  meta: null,
};

const FieldHistorySummarySlice = createSlice({
  name: 'fieldHistorySummary',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFieldHistorySummary.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFieldHistorySummary.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.data = action.payload.summary;
        state.meta = action.payload.pagination;
      })
      .addCase(fetchFieldHistorySummary.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? null;
      });
  },
});

export default FieldHistorySummarySlice.reducer;